export interface ParsedIngenicoResponse {
  ascii?: string
  authCode?: string
  errorMessage?: string
  esito?: string
  ok: boolean
  panMasked?: string
  raw: string
  transType?: string
}

function hexToBytes(hex: string): number[] {
  const clean = hex.replace(/\s+/g, '').toLowerCase()
  const bytes: number[] = []
  for (let i = 0; i + 1 < clean.length; i += 2) {
    bytes.push(parseInt(clean.slice(i, i + 2), 16))
  }
  return bytes
}

export function parseProtocol17Response(rawHex: string): ParsedIngenicoResponse {
  if (!rawHex) {
    return { errorMessage: 'empty response', ok: false, raw: rawHex }
  }

  const bytes = hexToBytes(rawHex)
  if (bytes.length === 0) {
    return { errorMessage: 'empty response', ok: false, raw: rawHex }
  }

  if (bytes[0] === 0x15) {
    return { errorMessage: 'NAK', ok: false, raw: rawHex }
  }

  const stxIdx = bytes.indexOf(0x02)
  if (stxIdx === -1) {
    return { errorMessage: 'no STX in response', ok: false, raw: rawHex }
  }

  const etxIdx = bytes.indexOf(0x03, stxIdx + 1)
  if (etxIdx === -1) {
    return { errorMessage: 'no ETX in response', ok: false, raw: rawHex }
  }

  const ascii = bytes
    .slice(stxIdx + 1, etxIdx)
    .map((b) => String.fromCharCode(b))
    .join('')

  const esito = ascii.substring(10, 12)

  if (esito === '00') {
    return {
      ascii,
      authCode: ascii.substring(34, 40).trim(),
      esito,
      ok: true,
      panMasked: ascii.substring(12, 31).trim(),
      raw: rawHex,
      transType: ascii.substring(31, 34).trim(),
    }
  }

  return {
    ascii,
    errorMessage: ascii.substring(12, 36).trim(),
    esito,
    ok: false,
    raw: rawHex,
  }
}
